import { render, staticRenderFns } from "./ProductAlternativeImage.vue?vue&type=template&id=66998896&scoped=true"
import script from "./ProductAlternativeImage.vue?vue&type=script&lang=js"
export * from "./ProductAlternativeImage.vue?vue&type=script&lang=js"
import style0 from "./ProductAlternativeImage.vue?vue&type=style&index=0&id=66998896&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../productWidget/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66998896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/productWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66998896')) {
      api.createRecord('66998896', component.options)
    } else {
      api.reload('66998896', component.options)
    }
    module.hot.accept("./ProductAlternativeImage.vue?vue&type=template&id=66998896&scoped=true", function () {
      api.rerender('66998896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "buybuttoncompact/src/components/ProductAlternativeImage.vue"
export default component.exports